/* Mind Glow Glass — Illuminated House Signs: collection, model pages and configurator.
 * One Shopify page; the view is chosen by ?model=. With a linked product (data-buy) each size is a Shopify variant:
 * the price shown is the variant price rendered by Shopify, and Add to Cart posts the variant with the design and
 * personalisation as line item properties. Without it, enquiries go to the quote page (read by mgg-quote.liquid).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-mhs]');
  if (!root || !window.MGGSign) return;

  var M = MGGSign.MODELS, SIZES = MGGSign.SIZES, LED = MGGSign.LED, LIGHTING = MGGSign.LIGHTING;
  var LIMITS = { number: 6, street: 36, house: 28, notes: 500 };
  var QUOTE_URL = root.getAttribute('data-quote-url') || '/pages/request-a-quote';
  var PAGE_URL = location.pathname;
  var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  var narrow = function () { return window.matchMedia('(max-width: 760px)').matches; };

  /* ---------- Shopify variants (one per size) ---------- */
  var BUY = root.hasAttribute('data-buy'), FROM = root.getAttribute('data-from') || '', VARIANTS = [];
  if (BUY) {
    try { VARIANTS = JSON.parse(root.querySelector('[data-mhs-variants]').textContent); } catch (e) { VARIANTS = []; }
    // A variant belongs to a size when its Size option names the same millimetres, e.g. "300 × 200 mm".
    VARIANTS.forEach(function (v) {
      var m = String(v.size || '').match(/(\d+)\s*[×x]\s*(\d+)/); v.idx = -1;
      if (m) SIZES.forEach(function (z, i) { if (z[0] === +m[1] && z[1] === +m[2]) v.idx = i; });
    });
    VARIANTS = VARIANTS.filter(function (v) { return v.idx >= 0; });
    BUY = VARIANTS.length > 0;
  }
  function variantFor(i) { for (var k = 0; k < VARIANTS.length; k++) if (VARIANTS[k].idx === i) return VARIANTS[k]; return null; }
  function sellable(i) {
    if (!BUY || variantFor(i)) return i;
    var best = VARIANTS[0].idx;
    VARIANTS.forEach(function (v) { if (Math.abs(v.idx - i) < Math.abs(best - i)) best = v.idx; });
    return best;
  }

  function mount(el, cfg) {
    el.innerHTML = MGGSign.render(cfg);
    MGGSign.fitTexts(el);
    fontsReady.then(function () { MGGSign.fitTexts(el); });
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function sizeLabel(i, ori) { var z = SIZES[i]; return ori === 'v' ? z[1] + ' × ' + z[0] + ' mm' : z[0] + ' × ' + z[1] + ' mm'; }

  /* ---------- state in the URL ---------- */
  var q = new URLSearchParams(location.search);
  var modelKey = M[q.get('model')] ? q.get('model') : null;

  function readState(model) {
    var d = M[model].defaults;
    function pick(k, def, ok) { var v = q.get(k); return v !== null && (!ok || ok(v)) ? v : def; }
    // Buying: text fields start empty (the preview shows example text until the customer types their own).
    var t = BUY ? { number: '', street: '', house: '' } : d;
    return {
      model: model,
      touched: BUY && (q.has('number') || q.has('street') || q.has('house')),
      notes: '',
      size: sellable(+pick('size', d.size, function (v) { return /^[0-4]$/.test(v); })),
      orientation: pick('ori', d.orientation, function (v) { return v === 'h' || v === 'v'; }),
      lighting: pick('light', 'both', function (v) { return !!LIGHTING[v]; }),
      led: pick('led', 'warm', function (v) { return !!LED[v]; }),
      number: pick('number', t.number).slice(0, LIMITS.number),
      street: pick('street', t.street).slice(0, LIMITS.street),
      house: pick('house', t.house).slice(0, LIMITS.house),
      time: pick('time', 'night', function (v) { return v === 'day' || v === 'night'; }),
      view: pick('view', 'facade', function (v) { return v === 'facade' || v === 'closeup' || v === 'build'; })
    };
  }
  function params(s) {
    var uses = M[s.model].uses;
    var p = { model: s.model, size: s.size, ori: s.orientation, light: s.lighting, led: s.led };
    if (uses.indexOf('number') >= 0) p.number = s.number;
    if (uses.indexOf('street') >= 0) p.street = s.street;
    if (uses.indexOf('house') >= 0) p.house = s.house;
    return p;
  }
  function shown(s, k) { return s[k] || (BUY && !s.touched ? M[s.model].defaults[k] : ''); }
  function signCfg(s, extra) {
    var z = SIZES[s.size], o = {
      model: s.model, wmm: z[0], hmm: z[1], orientation: s.orientation, lighting: s.lighting, led: s.led,
      number: shown(s, 'number'), street: shown(s, 'street'), house: M[s.model].uses.indexOf('house') >= 0 ? shown(s, 'house') : '',
      time: s.time, view: s.view === 'build' ? 'facade' : s.view
    };
    for (var k in extra) o[k] = extra[k];
    return o;
  }

  /* ---------- collection view ---------- */
  function renderCollection() {
    var grid = root.querySelector('[data-mhs-grid]');
    if (!grid) return;
    Object.keys(M).forEach(function (key, i) {
      var m = M[key], d = m.defaults;
      var base = { model: key, number: d.number, street: d.street, house: d.house,
        wmm: SIZES[d.size][0], hmm: SIZES[d.size][1], orientation: d.orientation, lighting: 'both',
        led: key === 'linear' || key === 'modern' ? 'cool' : 'warm',
        width: 1200, height: 900, signX: narrow() ? 720 : 760, signY: 420, zoom: narrow() ? 1.45 : 1.12 };
      var a = document.createElement('a');
      a.className = 'mhs-card mhs-card--' + (i + 1);
      a.href = PAGE_URL + '?model=' + key;
      a.innerHTML =
        '<div class="mhs-card__art"><span class="mhs-tod">Night</span><div class="mhs-n"></div><div class="mhs-d"></div></div>' +
        '<div class="mhs-card__meta"><div class="mhs-card__row"><span class="mhs-k">0' + (i + 1) + '</span><h2 class="mhs-card__t">' + m.name + '</h2></div>' +
        '<p class="mhs-card__tag">' + esc(m.tagline) + '</p><p class="mhs-card__p">' + esc(m.description) + '</p>' +
        '<div class="mhs-card__foot">' + (BUY ? '<span class="mhs-card__price">From ' + esc(FROM) + '</span>' : '<span class="mhs-tbc">Request a personalised quote</span>') + '<span class="mhs-go">Configure <span aria-hidden="true">→</span></span></div></div>';
      grid.appendChild(a);
      mount(a.querySelector('.mhs-n'), Object.assign({}, base, { time: 'night' }));
      mount(a.querySelector('.mhs-d'), Object.assign({}, base, { time: 'day' }));
      var tod = a.querySelector('.mhs-tod');
      a.addEventListener('mouseenter', function () { tod.textContent = 'Day'; });
      a.addEventListener('mouseleave', function () { tod.textContent = 'Night'; a.classList.remove('is-day'); });
      a.addEventListener('touchstart', function () { a._t = true; }, { passive: true });
      a.addEventListener('click', function (e) {
        if (a._t && !a.classList.contains('is-day')) { e.preventDefault(); a.classList.add('is-day'); tod.textContent = 'Day'; }
      });
    });
    var art = root.querySelector('[data-mhs-light-art]'), demo = root.querySelector('[data-mhs-light-demo]');
    if (art && demo) {
      var lc = { model: 'classic', number: '27', street: 'Hawthorn Avenue', wmm: 300, hmm: 200, time: 'night',
        led: 'warm', lighting: 'both', view: 'closeup', width: 1200, height: 800, facade: 'render' };
      Object.keys(LIGHTING).forEach(function (k) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mhs-chip' + (k === 'both' ? ' is-on' : ''); b.textContent = LIGHTING[k];
        b.setAttribute('aria-pressed', k === 'both');
        b.onclick = function () {
          lc.lighting = k;
          [].forEach.call(demo.children, function (c) { c.classList.toggle('is-on', c === b); c.setAttribute('aria-pressed', c === b); });
          mount(art, lc);
        };
        demo.appendChild(b);
      });
      mount(art, lc);
    }
  }

  /* ---------- model view + configurator ---------- */
  function renderModel() {
    var s = readState(modelKey);
    var scene = root.querySelector('[data-mhs-scene]');
    var thumbs = root.querySelector('[data-mhs-thumbs]');
    var VIEWS = [
      { label: 'Night', time: 'night', view: 'facade' },
      { label: 'Day', time: 'day', view: 'facade' },
      { label: 'Close-up', time: 'night', view: 'closeup' },
      { label: 'Construction', view: 'build' }
    ];

    function drawMain() {
      if (s.view === 'build') { scene.innerHTML = MGGSign.construction(); return; }
      var n = scene.clientWidth < 700;
      mount(scene, signCfg(s, { dims: true, width: n ? 900 : 1200, height: n ? 600 : 800, zoom: n ? 1.2 : 1,
        signX: n ? 560 : 744, signY: n ? 270 : 352 }));
    }
    var tt;
    function drawThumbs() {
      clearTimeout(tt);
      tt = setTimeout(function () {
        [].forEach.call(thumbs.children, function (b, i) {
          var v = VIEWS[i], h = b.querySelector('.mhs-thumb__a');
          if (v.view === 'build') { if (!h.innerHTML) h.innerHTML = MGGSign.construction(); }
          else mount(h, signCfg(s, { time: v.time, view: v.view, label: false, width: 1200, height: 800 }));
        });
      }, 160);
    }
    function syncTools() {
      [].forEach.call(root.querySelectorAll('[data-mhs-time] button'), function (b) {
        b.classList.toggle('is-on', b.dataset.v === s.time); b.disabled = s.view === 'build';
      });
      [].forEach.call(root.querySelectorAll('[data-mhs-view] button'), function (b) { b.classList.toggle('is-on', b.dataset.v === s.view); });
      [].forEach.call(thumbs.children, function (b, i) {
        var v = VIEWS[i];
        var on = v.view === 'build' ? s.view === 'build' : (v.view === s.view && (v.view === 'closeup' || v.time === s.time));
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      });
    }
    function summary() {
      var m = M[s.model], rows = [['Design', m.name], ['Size', sizeLabel(s.size, s.orientation)],
        ['Orientation', s.orientation === 'v' ? 'Portrait' : 'Landscape'], ['Illumination', LIGHTING[s.lighting]], ['LED colour', LED[s.led].label]];
      if (m.uses.indexOf('number') >= 0 && s.number) rows.push(['House number', s.number]);
      if (m.uses.indexOf('street') >= 0 && s.street) rows.push(['Street name', s.street.toUpperCase()]);
      if (m.uses.indexOf('house') >= 0 && s.house) rows.push(['House name', s.house]);
      if (BUY && s.notes.trim()) rows.push(['Instructions', s.notes.trim().length > 60 ? s.notes.trim().slice(0, 57) + '…' : s.notes.trim()]);
      return '<dl>' + rows.map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('') + '</dl>';
    }
    function texts() {
      var m = M[s.model];
      root.querySelector('[data-mhs-title]').textContent = m.name;
      root.querySelector('[data-mhs-crumb]').textContent = m.name;
      root.querySelector('[data-mhs-tag]').textContent = m.tagline;
      root.querySelector('[data-mhs-desc]').textContent = m.description;
    }
    function update() {
      texts(); drawMain(); drawThumbs(); syncTools();
      root.querySelector('[data-mhs-summary]').innerHTML = summary();
      var p = params(s), qs = new URLSearchParams(p).toString();
      history.replaceState(null, '', PAGE_URL + '?' + qs);
      var quote = new URLSearchParams(p); quote.set('enquiry', 'house-sign');
      root.querySelector('[data-mhs-quote]').href = QUOTE_URL + '?' + quote.toString() + '#enquiry-form';
      if (BUY) {
        var v = variantFor(s.size);
        root.querySelector('[data-mhs-variant]').value = v.id;
        ['[data-mhs-price]', '[data-mhs-sum-price]', '[data-mhs-btn-price]'].forEach(function (sel) {
          var el = root.querySelector(sel); if (el) el.textContent = v.price;
        });
        root.querySelector('[data-mhs-add]').disabled = !v.available;
      }
    }

    VIEWS.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mhs-thumb';
      b.innerHTML = '<div class="mhs-thumb__a"></div><span>' + v.label + '</span>';
      b.onclick = function () { s.view = v.view; if (v.time) s.time = v.time; update(); };
      thumbs.appendChild(b);
    });
    root.querySelector('[data-mhs-time]').addEventListener('click', function (e) {
      var v = e.target.closest('button'); if (!v || s.view === 'build') return; s.time = v.dataset.v; update();
    });
    root.querySelector('[data-mhs-view]').addEventListener('click', function (e) {
      var v = e.target.closest('button'); if (!v) return; s.view = v.dataset.v; update();
    });
    buildOptions(root.querySelector('[data-mhs-cfg]'), s, update);
    if (BUY) bindCart(s);
    var build = root.querySelector('[data-mhs-build]');
    if (build) build.innerHTML = MGGSign.construction();
    update();
  }

  function chipGroup(opts, cur, onPick) {
    var w = document.createElement('div'); w.className = 'mhs-chips';
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mhs-chip' + (o.cls ? ' ' + o.cls : '') + (o.value === cur ? ' is-on' : '');
      b.innerHTML = o.html || esc(o.label); b.setAttribute('aria-pressed', o.value === cur);
      b.onclick = function () {
        [].forEach.call(w.children, function (c) { c.classList.toggle('is-on', c === b); c.setAttribute('aria-pressed', c === b); });
        onPick(o.value);
      };
      w.appendChild(b);
    });
    return w;
  }
  function opt(label) {
    var d = document.createElement('div'); d.className = 'mhs-opt';
    d.innerHTML = '<div class="mhs-opt__l"><span>' + label + '</span><em></em></div>';
    return d;
  }

  function buildOptions(box, s, onChange) {
    var subs = {}, fields = {};
    function changed() { refresh(); onChange(); }

    subs.model = opt('Design');
    subs.model.appendChild(chipGroup(Object.keys(M).map(function (k) { return { value: k, label: M[k].name }; }), s.model, function (v) {
      s.model = v; var d = M[v].defaults;
      if (!BUY && !s.number) s.number = d.number;
      if (!BUY && M[v].uses.indexOf('house') >= 0 && !s.house) s.house = d.house;
      sync(); changed();
    }));
    subs.size = opt('Size');
    if (BUY) {
      subs.size.appendChild(chipGroup(VARIANTS.map(function (v) {
        var z = SIZES[v.idx];
        return { value: v.idx, cls: 'mhs-chip--size', html: '<b>' + z[0] + ' × ' + z[1] + ' mm</b><small>' + esc(v.price) + '</small>' };
      }), s.size, function (v) { s.size = v; changed(); }));
      subs.size.insertAdjacentHTML('beforeend',
        '<div class="mhs-dims"><div><span>Overall Dimensions</span><strong data-mhs-overall></strong></div>' +
        '<div><span>Approximate Personalisation Area</span><strong data-mhs-area></strong></div></div>' +
        '<div class="mhs-parea"><h4>Personalisation Area</h4><p>Due to the LED frame and mounting construction, the usable area for your house number or text is approximately 40 mm smaller on each side than the overall sign dimensions.</p></div>');
    } else {
      subs.size.appendChild(chipGroup(SIZES.map(function (z, i) { return { value: i, label: z[0] + ' × ' + z[1] }; }), s.size, function (v) { s.size = v; changed(); }));
      subs.size.insertAdjacentHTML('beforeend', '<p class="mhs-hint">Millimetres. Minimum planned size 200 × 150 mm — subject to production confirmation.</p>');
    }
    subs.ori = opt('Orientation');
    subs.ori.appendChild(chipGroup([
      { value: 'h', html: '<span class="mhs-ori" style="width:20px;height:13px"></span>Landscape' },
      { value: 'v', html: '<span class="mhs-ori" style="width:13px;height:20px"></span>Portrait' }
    ], s.orientation, function (v) { s.orientation = v; changed(); }));
    subs.light = opt('Illumination');
    subs.light.appendChild(chipGroup(Object.keys(LIGHTING).map(function (k) { return { value: k, label: LIGHTING[k] }; }), s.lighting, function (v) { s.lighting = v; changed(); }));
    subs.led = opt('LED colour');
    subs.led.appendChild(chipGroup([
      { value: 'warm', html: '<span class="mhs-dot" style="background:#FFC57E;box-shadow:0 0 8px #FFB760"></span>Warm White 3000K' },
      { value: 'cool', html: '<span class="mhs-dot" style="background:#E4EEFF;box-shadow:0 0 8px #BFD7FF"></span>Cool White 6000K' }
    ], s.led, function (v) { s.led = v; changed(); }));

    var txt = opt(BUY ? 'Personalisation' : 'Your text');
    var FIELDS = BUY
      ? [['number', 'House Number <span class="mhs-req">*</span>'], ['street', 'Street Name (optional)'], ['house', 'House Name (optional)'], ['notes', 'Additional Instructions (optional)']]
      : [['number', 'House number'], ['street', 'Street name'], ['house', 'House name']];
    FIELDS.forEach(function (f) {
      var w = document.createElement('div'), id = 'mhs-f-' + f[0];
      w.className = 'mhs-field';
      w.innerHTML = '<label for="' + id + '"><span>' + f[1] + '</span><span class="mhs-cnt"></span></label>' +
        (f[0] === 'notes' ? '<textarea id="' + id + '" maxlength="' + LIMITS.notes + '" rows="3"></textarea>'
          : '<input id="' + id + '" maxlength="' + LIMITS[f[0]] + '" autocomplete="off"' + (BUY && f[0] === 'number' ? ' required aria-required="true"' : '') + '>');
      var inp = w.querySelector('input,textarea');
      inp.addEventListener('input', function () {
        s[f[0]] = inp.value; if (f[0] !== 'notes') s.touched = true;
        w.classList.remove('is-bad'); count(f[0]); onChange();
      });
      fields[f[0]] = w; txt.appendChild(w);
    });
    var hint = document.createElement('p'); hint.className = 'mhs-hint'; txt.appendChild(hint);
    [subs.model, subs.size, subs.ori, subs.light, subs.led, txt].forEach(function (n) { box.appendChild(n); });

    function count(k) {
      var on = k === 'notes' || M[s.model].uses.indexOf(k) >= 0;
      fields[k].querySelector('.mhs-cnt').textContent = on ? s[k].length + ' / ' + LIMITS[k] : 'Not used on ' + M[s.model].name;
    }
    function sync() {
      ['number', 'street', 'house'].forEach(function (k) {
        var on = M[s.model].uses.indexOf(k) >= 0, inp = fields[k].querySelector('input');
        fields[k].classList.toggle('is-off', !on); inp.disabled = !on; inp.value = s[k]; count(k);
        if (BUY) inp.placeholder = on && M[s.model].defaults[k] ? 'e.g. ' + M[s.model].defaults[k] : '';
      });
      if (fields.notes) { fields.notes.querySelector('textarea').value = s.notes; count('notes'); }
      hint.textContent = BUY
        ? (s.model === 'custom'
          ? 'CUSTOM: the motif shown is an example. Describe your own artwork or lettering in Additional Instructions; we confirm the design with you by email before production.'
          : 'Street name is shown in capitals. The preview shows example text until you type your own.')
        : (s.model === 'custom'
          ? 'CUSTOM: the motif shown is an example. Your own artwork or lettering is agreed with you at quote stage.'
          : 'Street name is shown in capitals. Leave a field empty to remove it from the design.');
    }
    function refresh() {
      subs.model.querySelector('em').textContent = M[s.model].name;
      subs.size.querySelector('em').textContent = sizeLabel(s.size, s.orientation);
      subs.ori.querySelector('em').textContent = s.orientation === 'v' ? 'Portrait' : 'Landscape';
      subs.light.querySelector('em').textContent = LIGHTING[s.lighting];
      subs.led.querySelector('em').textContent = LED[s.led].label;
      if (BUY) {
        var z = SIZES[s.size], w = s.orientation === 'v' ? z[1] : z[0], h = s.orientation === 'v' ? z[0] : z[1];
        box.querySelector('[data-mhs-overall]').textContent = w + ' × ' + h + ' mm';
        box.querySelector('[data-mhs-area]').textContent = 'approx. ' + (w - 80) + ' × ' + (h - 80) + ' mm';
        subs.size.querySelector('em').textContent = sizeLabel(s.size, s.orientation) + ' · ' + variantFor(s.size).price;
      }
    }
    if (BUY) box.mhsField = function (k) { return fields[k]; };
    sync(); refresh();
  }

  /* ---------- Add to Cart: variant + line item properties ---------- */
  function bindCart(s) {
    var form = root.querySelector('[data-mhs-form]'), box = root.querySelector('[data-mhs-cfg]');
    var props = form.querySelector('[data-mhs-props]'), err = form.querySelector('[data-mhs-err]');
    var add = form.querySelector('[data-mhs-add]');
    form.addEventListener('submit', function (e) {
      var m = M[s.model], number = s.number.trim();
      if (!number) {
        e.preventDefault();
        var f = box.mhsField('number'); f.classList.add('is-bad');
        err.textContent = 'Please enter your house number.'; err.hidden = false;
        f.querySelector('input').focus();
        return;
      }
      err.hidden = true;
      var p = [['Design', m.name], ['Orientation', s.orientation === 'v' ? 'Portrait' : 'Landscape'],
        ['Illumination', LIGHTING[s.lighting]], ['LED Colour', LED[s.led].label], ['House Number', number]];
      if (m.uses.indexOf('street') >= 0 && s.street.trim()) p.push(['Street Name', s.street.trim()]);
      if (m.uses.indexOf('house') >= 0 && s.house.trim()) p.push(['House Name', s.house.trim()]);
      if (s.notes.trim()) p.push(['Additional Instructions', s.notes.trim()]);
      props.innerHTML = '';
      p.forEach(function (r) {
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + r[0] + ']'; i.value = r[1];
        props.appendChild(i);
      });
      form.querySelector('[data-mhs-variant]').value = variantFor(s.size).id;
      add.disabled = true;
    });
    // Back button (bfcache) must not leave the button disabled.
    window.addEventListener('pageshow', function () { add.disabled = !variantFor(s.size).available; });
  }

  root.setAttribute('data-view', modelKey ? 'model' : 'collection');
  if (modelKey) renderModel(); else renderCollection();
})();
